const skillStatusList = {
    'p10': 'TOP 10%',
    'p20': 'TOP 20%',
    'p30': 'TOP 30%',
    'p_rest': 'PASSED'
};

const baseBiData = {
    type: 'seller_page.show$viewport',
    page: {
        component: {
            parent_name: 'seller_card_about_me_list'
        },
        element: {
            type: 'text',
            metadata: 'Skill tests',
            visible: true
        }
    }
};

export const buildSellerCardAboutMeSkillTestsEvent = (biData, title) => ({
    ...baseBiData,
    group: 'seller_card_about_me_skill_tests_test_name_impression',
    seller: {
        id: biData.sellerId
    },
    page: {
        ...baseBiData.page,
        ctx_id: biData.pageCtxId,
        component: { ...baseBiData.page.component, name: 'seller_card_about_me_skill_tests_test_name' },
        element: {
            ...baseBiData.page.element,
            position: biData.position,
            text: title,
            name: 'seller_card_about_me_skill_tests_test_name',
            sub_element_count: 1
        }
    }
});

export const buildSellerCardAboutMeSkillTestsScoreEvent = (biData, scoreFragment) => ({
    ...baseBiData,
    group: 'seller_card_about_me_skill_tests_score_impression',
    seller: {
        id: biData.sellerId
    },
    page: {
        ...baseBiData.page,
        ctx_id: biData.pageCtxId,
        component: { ...baseBiData.page.component, name: 'seller_card_about_me_skill_tests_score' },
        element: {
            ...baseBiData.page.element,
            position: biData.position,
            text: `${scoreFragment}/10`,
            name: 'seller_card_about_me_skill_tests_score',
            sub_element_count: 2
        }
    }
});

export const buildSellerCardAboutMeSkillTestsScoreLabelEvent = (biData, status) => ({
    ...baseBiData,
    group: 'seller_card_about_me_skill_tests_score_label_impression',
    seller: {
        id: biData.sellerId
    },
    page: {
        ...baseBiData.page,
        ctx_id: biData.pageCtxId,
        component: { ...baseBiData.page.component, name: 'seller_card_about_me_skill_tests_score_label' },
        element: {
            ...baseBiData.page.element,
            position: biData.position,
            text: skillStatusList[status],
            name: 'seller_card_about_me_skill_tests_score_label',
            sub_element_count: 3
        }
    }
});
